import type { ICart } from '@inter-ikea-kompis/types/lib/index.js';
import { IframeUtility } from '@inter-ikea-kompis/utilities';

/**
 * This class handles communication with the IRW application through post message.
 */
export default class IrwPlatformCommunication {
	private readonly applicationName: string;

	/**
	 * Constructor.
	 *
	 * @param options Options.
	 * @param options.applicationName Application name.
	 */
	constructor(options: { applicationName: string }) {
		this.applicationName = options.applicationName;
	}

	/**
	 * Sets the iframe container height.
	 *
	 * @param height Height to set.
	 */
	public setIframeHeight(height: number): void {
		if (IframeUtility.isInsideIframe()) {
			window.parent.postMessage(
				{
					header: {
						name: 'setContainerSize'
					},

					body: {
						height: height,
						containerName: this.getContainerName()
					}
				},

				'*'
			);
		}
	}

	/**
	 * Sets the cart count.
	 *
	 * @param cartCount Cart count to set.
	 */
	public setCartCount(cartCount: ICart['cartCount']): void {
		if (IframeUtility.isInsideIframe()) {
			window.parent.postMessage(
				{
					header: {
						name: 'shoppingcartCount'
					},

					body: {
						count: cartCount,
						containerName: this.getContainerName()
					}
				},

				'*'
			);
		}
	}

	/**
	 * Returns the iframe container name.
	 *
	 * @returns Iframe container name.
	 */
	private getContainerName(): string {
		return '#' + this.applicationName + '-application';
	}
}
